export enum StudyModality {
  RESIDENT = 'RESIDENT',
  SPECIALIZING = 'SPECIALIZING'
}
